import useSelector from '@app/hooks/useSelector';

import { getDataRange } from '../../../../reducers/downloadData/selectors';
import DataRangeInput from './DataRangeInput';
import type { Value } from './types';
import { prepareIncomingValue, prepareOutgoingValue } from './utils/prepareData';

interface DataRangeInputContainerProps {
    value: Value;
    onChange: (value: Value) => void;
}

const DataRangeInputContainer = ({ value, onChange }: DataRangeInputContainerProps) => {
    const dataRange = useSelector(getDataRange);

    const inputValue = prepareIncomingValue(value, dataRange);

    return (
        <DataRangeInput
            value={inputValue}
            options={dataRange}
            onChange={(val, action) => onChange(prepareOutgoingValue(val, action))}
        />
    );
};

export default DataRangeInputContainer;
